var Flickity = require("flickity");

(function ($) {

  $(".flickity").each(function () {
    new Flickity($(this)[0], {
      cellAlign: "left",
      pageDots: false,
      draggable: ">2",
      contain: true,
    });
  })

  Drupal.behaviors.embrc = {
    attach: function (context, settings) {
      $("#header-desktop .menu--main .menu-item [data-menu]")
        .once()
        .mouseenter((e) => {
          $("#main-menu--sub .main-sub-menu [data-menu]").parent().hide();
          let menuId = $(e.currentTarget).data("menu");

          // Custom case: Services
          if (menuId == 'menu_link_content:38f2b860-a76f-4945-8239-c8b8f1af7b02') {
            $(".menu-services").removeClass('hidden')
          } else {
            $(".menu-services").addClass('hidden')
          }

          $("#title-menu").html($(e.currentTarget).data("menu-label"));
          $(`#main-menu--sub [data-menu="${menuId}"]`).parent().show();
          $("#main-menu--sub").removeClass("hide");
        });

      $("#main-menu--sub").once().mouseleave((e) => {
        setTimeout(() => {
          $("#main-menu--sub").addClass("hide");
        }, 500);
      });

      // SERVICES / SELECT COUNTRY / RefineInsituteOptionsList
      if ($(".view-id-services").length > 0) {
        if (!$('#edit-country').hasClass('on-change-defined')) {
          $('#edit-country').addClass('on-change-defined')
          refineInstituteOptionsList(false)
          document.getElementById("edit-country").addEventListener("change", function () {
            refineInstituteOptionsList(true);
          });
        }
      }

    },
  };
})(jQuery);

function refineInstituteOptionsList(reset) {
  const options = [
    {
      country: "26", options: ['RBINS', 'UHasselt', 'KULeuven', 'VLIZ', 'UGENT']
    }, // Belgium
    { country: "9", options: ['IMEV', 'OOB', 'SBR', 'SU'] }, // France
    { country: "10", options: ['HCMR-IMBBC'] }, // Greece
    { country: "11", options: ['IUI'] }, // Israel
    { country: "12", options: ['CNR-IAS-O', 'OGS', 'SZN', 'CONISMA-Camerino', 'CONISMA-Chioggia', 'CONISMA-Urbino', 'CNR-IAS-CG', 'CNR-IRBIM-L', 'CNR-IRBIM-M', 'CNR-ISMAR'] }, // Italy
    { country: "13", options: ['UO', 'UIB-MBSE', 'UIB-SICMMB', 'UIB-SLRC', 'IMR-ARS', 'NIVA', 'NTNU'] }, // Norway
    { country: "14", options: ['ACOI', 'CCMAR', 'CIIMAR', 'IMAR'] }, // Portugal
    { country: "15", options: ['ECIMAT-UVIGO', 'PiE-UPV/EHU'] }, // Spain
    { country: "16", options: ['NERC-BAS', 'SAMS', 'SOI', 'MBA', 'MSS'] }, // United Kingdom
  ]

  console.log('reset', reset)

  Array.from(document.querySelector("#edit-institute").options).forEach(function (option_element) {
    option_element.disabled = false
    if (option_element.value == 'All' && reset) {
      option_element.selected = true
    }
  });

  if (document.getElementById("edit-country").value != 'All') {
    let selected = options.find(item => item.country == document.getElementById("edit-country").value)
    Array.from(document.querySelector("#edit-institute").options).forEach(function (option_element) {
      if (!selected.options.includes(option_element.text) && option_element.value != "All") {
        option_element.disabled = true
      }
    });
  }

}

// GOOGLE MAP
const elMap = document.getElementById('map');
if (elMap) {
  window.initMap = function () {
    let map = new google.maps.Map(document.getElementById('map'), {
      zoom: 4,
      center: { lat: 54.197035169557466, lng: 15.669567164015763 },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    new KmlMapParser({
      showSidebar: false,
      map: map,
      kml: '/themes/custom/embrc/src/js/embrc_network.kml',
      zoomLevel: 4,
      useMapCenter: true,
      showFolders: true,
      afterParseFn: afterParse
    });

    function afterParse(data) {

      data.folders.forEach((folder) => {
        folder.placemarks.forEach((placemark) => {
          placemark.marker.setIcon('/themes/custom/embrc/src/images/map-pin.svg')
        })
      })

      if (elMap.dataset.country) {
        let bounds = new google.maps.LatLngBounds();
        let loc;
        let nbMarkers = 0

        data.folders.forEach((folder) => {
          folder.placemarks.forEach((placemark) => {
            if (folder.name != elMap.dataset.country) {
              placemark.marker.setVisible(false)
            }
            else {
              loc = new google.maps.LatLng(placemark.marker.position.lat(), placemark.marker.position.lng());
              bounds.extend(loc);
              nbMarkers++;

              placemark.marker.description = placemark.marker.description.replace(/<a.*a>/, '')
            }
          })
        })

        if (nbMarkers > 1) {
          map.fitBounds(bounds);
          map.panToBounds(bounds);
        }
        else {
          map.setCenter(loc);
          map.setZoom(10)
        }
        map.setOptions({ zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true });
      }
    }
  };

  var script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCj1p9eq3MTLOl-2D_61nRhoxLOT_bimFw&callback=initMap';
  script.defer = true;
  document.head.appendChild(script);
}
